export default __webpack_public_path__ + "static/media/workshop.0404de2c.jpg";